<template>
    <div class="modal fade text-left" id="vipModal" tabindex="3" role="dialog" aria-labelledby="myModalLabel1" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="myModalLabel1">{{ $t("labels.editValue") }}</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form class="form">
                        <lov-form :lov="editedlov"></lov-form>
                        <div class="form-actions">
                            <button type="button" class="btn btn-success" @click.prevent="$emit('saveedited')">
                            <i class="icon-note"></i> {{ $t("labels.save") }}
                            </button>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn grey btn-outline-secondary" data-dismiss="modal" ref='closeLovEditModal'>{{ $t("labels.close") }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LovForm from '@/components/lov/LovForm.vue'

export default {
    props: ["editedlov"],
    components: {
        LovForm
    }
}
</script>
